import { render, staticRenderFns } from "./ProgramView.vue?vue&type=template&id=da5a369e&scoped=true&"
import script from "./ProgramView.vue?vue&type=script&lang=js&"
export * from "./ProgramView.vue?vue&type=script&lang=js&"
import style0 from "./ProgramView.vue?vue&type=style&index=0&id=da5a369e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5a369e",
  null
  
)

export default component.exports